import React, { useEffect, useState } from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import { bg } from '../../../constants/component.constants';
import { changeBodyClassName } from '../../../utils/utils';
import PartnerHeader from './PartnerHeader';
import PersonalizeProfileModal from './PersonalizeProfileModal';
import { useAuth } from '../../auth/Auth';
import EventEmitter from '../../../utils/events';
import PersonalizeProfileCampCaptain from './PersonalizeProfileCampCaptain';
import unverifiedPatch from '../../../assets/icon/Bell_ic.svg';
import CampDashboardActivities from '../../mui/CampDashboardActivities';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useRecoilState } from 'recoil';
import { campTribesAtom, stepsEnabledAtom } from '../../../atoms/camp.atom';
import { schoolViewModel } from './school.view.model';
import CampActionButtons from './CampActionButtons';
import svg from '../../../assets/images/Avatar.svg';
import CampTour from './camp_tour/CampTour';
import RoundButton from '../../common/RoundButton';
import './camp-room.css';
import { Grid } from '@mui/material';
import CampCaptainTour from './camp_tour/CampCaptainTour';
import CaptainTourModal from './camp_tour/CaptainTourModal';

const theme = createTheme({
  palette: {
    background: {
      paper: '#fff',
    },
  },
});

const CampRoom = () => {
  const { school } = useAuth();
  const [customizePopup, setCustomizePopup] = useState(
    school && !school.description ? true : false
  );
  const [captainCustomizePopup, setCaptainCustomizePopup] = useState(false);
  const defaultProfileUrl =
    school && school.picture_url
      ? school.picture_url
      : school?.user_type === 'school_teacher'
      ? school?.profile?.picture_url
        ? school?.profile?.picture_url
        : svg
      : svg;
  const [profilePic, setProfilePic] = useState(defaultProfileUrl);
  const [campTribes, setCampTribes] = useRecoilState(campTribesAtom);
  const [selectedTribe, setSelectedTribe] = React.useState({ id: 0 });
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const [pageReady, setPageReady] = useState(false);
  const [showTourModal, setShowTourModal] = useState(false);

  useEffect(() => {
    setProfilePic(defaultProfileUrl);
  }, [defaultProfileUrl]);

  const getUserProfilePic = (image) => {
    setProfilePic(image.preview);
  };

  EventEmitter.subscribe('partner_profile_pic', getUserProfilePic);

  useEffect(() => {
    changeBodyClassName([bg.WHITE]);
  }, []);

  const partnerBadge = () => {
    switch (school?.user_type) {
      case 'camp master':
        return 'Expert';
      case 'partner':
        return 'Partner';
      case 'school':
        return 'Camp Master';
      case 'school_teacher':
        return 'Camp Captain';
      default:
        break;
    }
  };

  const subscriptionType = () => {
    switch (school?.subcription_type) {
      case 'premium':
        return 'Premium';
      case 'standard':
        return 'Standard';
      default:
        return 'Standard';
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (school && !campTribes) {
          let API =
            school?.user_type === 'school'
              ? schoolViewModel?.getCampMasterTribes
              : schoolViewModel?.getCampCaptainTribes;
          let temp = [{ id: 0, name: 'All Tribes' }];
          const params = {
            limit: 99,
          };

          await API(school?.id, params)
            .then((res) => {
              setCampTribes([...temp, ...res]); // Append temp as the first object
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Check if the page has fully loaded (or the elements exist)
    const checkElements = setInterval(() => {
      if (document.querySelector('#step-one')) {
        setPageReady(true);
        clearInterval(checkElements);
      }
    }, 100); // Check every 100ms

    return () => clearInterval(checkElements);
  }, []);

  const handleTour = () => {
    // setStepsEnabled(!stepsEnabled);
    setShowTourModal(!showTourModal);
  };

  return (
    <div className="treehouse-details partner-setting-wrapper partner-wrapper-main">
      <PartnerHeader />
      {school.user_type === 'school' && (
        <CampTour
          stepsEnabled={stepsEnabled}
          setStepsEnabled={setStepsEnabled}
        />
      )}
      {/* {school.user_type === "school_teacher" && <CampCaptainTour stepsEnabled={stepsEnabled} setStepsEnabled={setStepsEnabled} tribesList={campTribes || []} />} */}
      <Container className="setting-container setting-wrap" fluid="md">
        <Row className="middle-section guardian-row-box">
          <Row style={{ width: '100%' }}>
            <Col
              className="welcome"
              style={{ paddingTop: '20px', paddingBottom: '20px' }}
            >
              {selectedTribe?.id === 0
                ? `Welcome ${school?.first_name}`
                : 'Tribe informations'}
            </Col>
            <Col className="start-tour" style={{ display: 'contents' }}>
              {selectedTribe?.id === 0 && (
                <RoundButton
                  type="button"
                  label="Start tour"
                  className="transparent-button d-sm-block tour-top-btn"
                  onClick={handleTour}
                  style={{ width: '150px' }}
                />
              )}
            </Col>
          </Row>
          <Row className="kid-box vertical-height activated insights-dashboard">
            <Col className="avatar-wrapper" style={{ height: 'auto' }}>
              <div className="normal-type">
                <div className="avatar-image">
                  <Image
                    className={`rounded-circle dashboard-kid-avatar`}
                    style={{
                      width: '100px',
                      height: '100px',
                      position: 'relative',
                      display: 'inline-flex',
                    }}
                    src={
                      selectedTribe?.id === 0
                        ? profilePic
                        : selectedTribe?.group_captain?.picture_url
                        ? selectedTribe?.group_captain?.picture_url
                        : svg
                    }
                  />
                  {school && !school.is_verified ? (
                    <span className={'unverified-patch remove-pointer'}>
                      <Image src={unverifiedPatch} />
                      Unverified
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <div className="user-info">
                  <div className="user-name">
                    {selectedTribe?.id === 0
                      ? `${school && school.first_name} ${
                          school && school.last_name
                        }`
                      : selectedTribe?.name}
                  </div>
                  <div className="full-name">
                    {school && school.user_type === 'school'
                      ? school.school_name
                      : school.name_of_organisation}
                  </div>
                  <Grid
                    container
                    direction={{ xs: 'column', sm: 'column', md: 'row' }} // Column on small screens, row on medium and up
                    spacing={2} // Keep spacing for spacing left/right, but override top padding
                  >
                    {/* First Item - No Padding */}
                    <Grid
                      item
                      sx={{
                        paddingTop: '16px !important', // Override default top padding
                      }}
                    >
                      <div className={`subscription`}>
                        <span className="current-plan">
                          {selectedTribe?.id === 0
                            ? partnerBadge()
                            : `Camp Captain: ${selectedTribe?.group_captain?.first_name} ${selectedTribe?.group_captain?.last_name}`}
                        </span>
                      </div>
                    </Grid>

                    {/* Subsequent Items */}
                    {(school &&
                      selectedTribe?.id === 0 &&
                      school.user_type === 'school') ||
                    school.user_type === 'school_teacher' ? (
                      <Grid
                        item
                        sx={{
                          paddingTop: {
                            xs: '5px !important',
                            sm: '5px !important',
                            md: '16px !important',
                          }, // Apply custom top padding
                        }}
                      >
                        <div id="step-one" className={`subscription`}>
                          <span
                            className="current-plan"
                            style={{ backgroundColor: '#fcba03' }}
                          >
                            {subscriptionType()}
                          </span>
                        </div>
                      </Grid>
                    ) : null}

                    {/* Another Conditional Item */}
                    {school?.user_type === 'school_teacher' &&
                      school?.school_name && (
                        <Grid
                          item
                          sx={{
                            paddingTop: {
                              xs: '5px !important',
                              sm: '5px !important',
                              md: '16px !important',
                            }, // Apply custom top padding
                          }}
                        >
                          <div className={`subscription`}>
                            <span className="current-plan">
                              Camp: {school?.school_name}
                            </span>
                          </div>
                        </Grid>
                      )}
                  </Grid>
                </div>
              </div>
            </Col>
            <Col className="command-wrapper">
              <CampActionButtons
                selectedTribe={selectedTribe}
                stepsEnabled={stepsEnabled}
              />
            </Col>
            <ThemeProvider theme={theme}>
              <Row className="myroom-info-wrapper slider-cards short_second_card_row challenges-progress1">
                <Col className="myroom-collapse insights-soon most-complimented-creation mood-creation">
                  <CampDashboardActivities
                    tribes={campTribes || []}
                    selectedTribe={selectedTribe}
                    setSelectedTribe={setSelectedTribe}
                    stepsEnabled={stepsEnabled}
                  />
                </Col>
              </Row>
            </ThemeProvider>
          </Row>
        </Row>
      </Container>
      {school?.user_type === 'school' ? (
        <PersonalizeProfileModal
          customizePopup={customizePopup}
          setCustomizePopup={setCustomizePopup}
          isEdit={!school.description ? false : true}
        />
      ) : (
        <PersonalizeProfileCampCaptain
          customizePopup={captainCustomizePopup}
          setCustomizePopup={setCaptainCustomizePopup}
          isEdit={!school?.profile?.picture_url ? false : true}
        />
      )}
      {/* {stepsEnabled && pageReady && <CampCaptainTour tribesList={campTribes} />} */}
      {showTourModal && (
        <CaptainTourModal
          showModal={showTourModal}
          setShowModal={setShowTourModal}
        />
      )}
    </div>
  );
};
export default CampRoom;